import { Search } from 'lucide-react';
import { useCallback } from 'react';
import { useRouter } from '@/i18n/routing';

// const FILTERS = [
//   {
//     key: 'co-khuyen-mai',
//     label: 'Khuyến mãi',
//     icon: <Percent className="size-4" />,
//   },
//   {
//     key: 'co-freeship',
//     label: 'Freeship',
//     icon: <Package className="size-4" />,
//   },
//   {
//     key: 'moi',
//     label: 'Mới',
//     icon: <Sparkles className="size-4" />,
//   },
//   {
//     key: 'co-hot-deal',
//     label: 'Hot Deal',
//     icon: <BadgePercent className="size-4" />,
//   },
// ];

export default function SearchAndFilterBar({ citySlug }: { citySlug: string }) {
  const router = useRouter();

  // Navigate to search listing when input is clicked or focused
  const handleInputClick = useCallback(() => {
    router.push(`/${citySlug}/danh-sach-cua-hang?focus=1`);
  }, [router, citySlug]);

  // const handleFilterToggle = useCallback(
  //   (key: string) => {
  //     router.push(`/${citySlug}/danh-sach-cua-hang-${key}`);
  //   },
  //   [citySlug, router]
  // );

  return (
    <div className="flex flex-col md:flex-row gap-3 mt-4 mb-3 w-full">
      <form
        onSubmit={(e) => e.preventDefault()}
        className="flex-1 flex gap-2 px-4"
      >
        <div className="relative w-full flex items-center">
          <input
            type="text"
            readOnly
            onClick={handleInputClick}
            onFocus={handleInputClick}
            placeholder="Tìm cửa hàng..."
            className="w-full pl-12 pr-4 py-3 bg-neutral-10 rounded-2xl h-12 text-neutral-90 cursor-pointer"
          />
          <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
            <Search className="size-5" />
          </div>
        </div>
      </form>
      {/* <div className="flex gap-2 py-1 px-0 overflow-x-auto scrollbar-hide ml-4">
        {FILTERS.map((f) => (
          <Button
            key={f.key}
            type="button"
            variant="outline"
            className={cn(
              'px-3 py-2 font-medium rounded-xl transition min-w-fit bg-white text-neutral-60 border-neutral-20'
            )}
            onClick={() => handleFilterToggle(f.key)}
          >
            <span className="inline-flex items-center gap-1">
              {f.icon}
              {f.label}
            </span>
          </Button>
        ))}
      </div> */}
    </div>
  );
}
